import { useSetRecoilState } from "recoil";

import {
    baseTariffState,
    brokerDataState,
    chosenTheftOptionState,
    currentAtticsAmount,
    currentCellarsAmount,
    currentExtrasAmount,
    currentGaragesAmount,
    currentOtherAmount,
    housingTypeState,
    insuranceState,
    isLegalCheckedState,
    isPackageCheckedState,
    isTheftCheckedState,
    optionTariffState,
    propertyCityState,
    propertyLetterBoxState,
    propertyNumberState,
    propertyPostalCodeState,
    propertyRisk,
    propertyStreetState,
    securityDoorState,
    totalPriceState,
    userTypeState,
    weTakeCareActivated,
    weTakeCareReason,
    weTakeCareStepout,
    yourInformationConsentState,
    yourInformationEmailState,
    yourInformationFirstNameState,
    yourInformationLastNameState,
    yourInformationPhoneState,
    yourInformationQuestionState,
} from "@states";
import { historyState } from "@states/history";

export function useClearData() {
    const setHousingType = useSetRecoilState(housingTypeState);
    const setBrokerData = useSetRecoilState(brokerDataState);
    const setYourInformationFirstname = useSetRecoilState(
        yourInformationFirstNameState,
    );
    const setYourInformationLastname = useSetRecoilState(
        yourInformationLastNameState,
    );
    const setYourInformationEmail = useSetRecoilState(
        yourInformationEmailState,
    );
    const setYourInformationPhone = useSetRecoilState(
        yourInformationPhoneState,
    );
    const setYourInformationQuestion = useSetRecoilState(
        yourInformationQuestionState,
    );
    const setYourInformationConstent = useSetRecoilState(
        yourInformationConsentState,
    );
    const setYourInformationStreet = useSetRecoilState(propertyStreetState);
    const setInsurance = useSetRecoilState(insuranceState);
    const setBaseTariff = useSetRecoilState(baseTariffState);
    const setOptionTariff = useSetRecoilState(optionTariffState);
    const setIsTheftChecked = useSetRecoilState(isTheftCheckedState);
    const setIsLegalChecked = useSetRecoilState(isLegalCheckedState);
    const setChosenTheftOption = useSetRecoilState(chosenTheftOptionState);
    const setPropertyNumber = useSetRecoilState(propertyNumberState);
    const setPropertyLetterBox = useSetRecoilState(propertyLetterBoxState);
    const setPropertyPostalCode = useSetRecoilState(propertyPostalCodeState);
    const setPropertyRisk = useSetRecoilState(propertyRisk);
    const setPropertyCity = useSetRecoilState(propertyCityState);
    const setCurrentOtherAmount = useSetRecoilState(currentOtherAmount);
    const setCurrentAtticsAmount = useSetRecoilState(currentAtticsAmount);
    const setCurrentGaragesAmount = useSetRecoilState(currentGaragesAmount);
    const setCurrentCellarsAmount = useSetRecoilState(currentCellarsAmount);
    const setCurrentExtrasAmount = useSetRecoilState(currentExtrasAmount);
    const setSecurityDoor = useSetRecoilState(securityDoorState);
    const setIsPackageChecked = useSetRecoilState(isPackageCheckedState);
    const setTotalPrice = useSetRecoilState(totalPriceState);
    const setWeTakeCareActivated = useSetRecoilState(weTakeCareActivated);
    const setWeTakeCareStepout = useSetRecoilState(weTakeCareStepout);
    const setWeTakeCareReason = useSetRecoilState(weTakeCareReason);
    const setUserType = useSetRecoilState(userTypeState);
    const setHistory = useSetRecoilState(historyState);

    const clearAll = () => {
        setHistory([]);
        setUserType(undefined);
        setBrokerData(undefined);
        setYourInformationFirstname("");
        setYourInformationLastname("");
        setYourInformationEmail("");
        setYourInformationPhone("");
        setYourInformationQuestion("");
        setYourInformationConstent(false);
        setYourInformationStreet(undefined);
        setInsurance(undefined);
        setBaseTariff(undefined);
        setOptionTariff([]);
        setYourInformationQuestion("");
        setIsTheftChecked(false);
        setIsLegalChecked(false);
        setChosenTheftOption("");
        setHousingType(undefined);
        setPropertyNumber("");
        setPropertyLetterBox("");
        setPropertyPostalCode("");
        setPropertyRisk(0);
        setPropertyCity(undefined);
        setCurrentOtherAmount(0);
        setCurrentAtticsAmount(0);
        setCurrentGaragesAmount(0);
        setCurrentCellarsAmount(0);
        setCurrentExtrasAmount(0);
        setSecurityDoor("no-door");
        setIsPackageChecked(false);
        setTotalPrice(0);
        setWeTakeCareActivated(false);
        setWeTakeCareStepout(false);
        setWeTakeCareReason({
            reason: undefined,
            page: undefined,
            businessRule: undefined,
        });
    };

    return { clearAll };
}
